import Link from "next/link"
import { MobileMediaCarousel, ProjectMetadata } from "../components"
import { FragmentType, graphql, useFragment } from "@/gql"
import { CreativeAvatarWithNameAndTitle } from "@/components"
import type { NovaSession } from "@/types"
import { DeleteProjectModal } from "./DeleteProjectModal"
import { IconButton } from "@/elements"
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline"
import { useRouter } from "next-nprogress-bar"
import { useState } from "react"

const ProjectMobileContentFragment = graphql(`
  fragment ProjectMobileContent on CreativeWorkPortfolioProject {
    id
    creator {
      id
      creative {
        id
        ... on IndividualCreative {
          ...CreativeAvatarWithNameAndTitle
        }
      }
    }
    ...ProjectMetadata
    ...MobileMediaCarousel
  }
`)

interface Props {
  project: FragmentType<typeof ProjectMobileContentFragment> | undefined | null
  userHref: string
  serverSession: NovaSession | null
  isViewersProject: boolean
}

export const ProjectMobileContent: React.FC<Props> = ({ userHref, serverSession, isViewersProject, ...props }) => {
  const project = useFragment(ProjectMobileContentFragment, props.project)
  const router = useRouter()
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)

  const onEdit = () => {
    const handle = serverSession?.user?.creative?.handle
    router.push(`/${handle}/projects/form?projectId=${project?.id}&entry=project`)
  }

  const onDelete = () => {
    setDeleteModalOpen(true)
  }

  return (
    <div className="my-4 grid w-full grid-cols-12 gap-4">
      <div className="relative col-span-12">
        <div className="mb-4 flex w-full flex-row items-center justify-between">
          <Link href={userHref}>
            <CreativeAvatarWithNameAndTitle creative={project?.creator?.creative} size="sm" variant="sm" />
          </Link>
          {isViewersProject ? (
            <>
              <DeleteProjectModal
                isOpen={deleteModalOpen}
                onOpenChange={setDeleteModalOpen}
                handle={serverSession?.user?.creative?.handle || ""}
                projectId={project?.id!}
              />
              <div className="flex flex-row items-center gap-2">
                <IconButton variant="white" Icon={PencilIcon} onClick={onEdit} data-prevent-nprogress={true} />
                <IconButton variant="white" Icon={TrashIcon} onClick={onDelete} />
              </div>
            </>
          ) : (
            <div />
          )}
        </div>
        <MobileMediaCarousel project={project} />
        {project && <ProjectMetadata project={project} mobile serverSession={serverSession} />}
      </div>
    </div>
  )
}
